import * as React from "react";

import { Link } from "react-router-dom";

const Footer = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <footer type={type} className="border-t-2 border-black py-8">
      <div className="px-4 sm:px-8 max-w-7xl mx-auto text-center">
        <p className="text-sm text-[#4B5563]">
          © 2026 Zeitex Sorteos. Todos los derechos reservados.
        </p>
        <div className="my-4 flex items-center justify-center gap-4">
          <a
            href="https://www.facebook.com/profile.php?id=61589662610265"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="w-8"
              src="/images/facebook-icon.svg"
              alt="Facebook"
            />
          </a>
          <a
            href="https://www.instagram.com/zeitexsorteos"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="w-8"
              src="/images/instagram-icon.svg"
              alt="Instagram"
            />
          </a>
        </div>
        <Link
          to="/privacy-policy"
          className="text-sm font-bold tracking-wider hover:text-[#FF3333] transition-colors"
        >
          Avisos de Privacidad
        </Link>
      </div>
    </footer>
  );
});
Footer.displayName = "Footer";

export { Footer };
